import Carousel from './carousel';
import limitedJsFunctionality from 'helpers/limitedJs';

export default {
  init: function (selector) {
    const carousels = document.querySelectorAll(selector);

    if (carousels && carousels.length && !limitedJsFunctionality) {
      [...carousels].forEach(item => {
        const options = item.getAttribute('data-carousel-options') || '{}';
        const carousel = new Carousel(item, JSON.parse(options));
        carousel.init();
      });
    }
  }
};
